var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.departureDetails.departureLegs.length &&
    _vm.departureDetails.departureNoFlights &&
    _vm.departureDetails.returnNoFlights
      ? _c("div", { staticClass: "departures__trips" }, [
          _c("div", { staticClass: "departures__trips-row" }, [
            _c("div", { staticClass: "departures__trip" }, [
              _c("div", { staticClass: "departures__simple" }, [
                _c("strong", [_vm._v("Start Date:")]),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.departureDetails.departureNoFlights.date) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "departures__simple" }, [
                _c("strong", [_vm._v("Location:")]),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.departureDetails.departureNoFlights.location) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "departures__trip" }, [
              _c("div", { staticClass: "departures__simple" }, [
                _c("strong", [_vm._v("End Date:")]),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.departureDetails.returnNoFlights.date) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "departures__simple" }, [
                _c("strong", [_vm._v("Location:")]),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.departureDetails.returnNoFlights.location) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "departures__trips" }, [
          _c(
            "div",
            { staticClass: "departures__trips-row" },
            [
              !_vm.departureDetails.allLegs.length
                ? _c("TripDetails", {
                    attrs: {
                      title: "Depart",
                      legs: _vm.departureDetails.departureLegs,
                      brand: _vm.brand,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.departureDetails.allLegs.length
                ? _c("TripDetails", {
                    attrs: {
                      title: "Return",
                      legs: _vm.departureDetails.returnLegs,
                      brand: _vm.brand,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.departureDetails.allLegs.length
                ? _vm._l(
                    _vm.departureDetails.allLegs,
                    function (flight, index) {
                      return _c(
                        "div",
                        {
                          key: flight.carrierCode,
                          staticClass: "checkout-end__summary-section",
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "checkout-end__summary-section-title",
                            },
                            [_vm._v("Flight " + _vm._s(index + 1))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _c("b", [_vm._v("Carrier")]),
                            _vm._v(
                              "\n              : " +
                                _vm._s(flight.flightCarrier.name) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _c("b", [_vm._v("Departure point")]),
                            _vm._v(
                              "\n              : " +
                                _vm._s(flight.departureAirport.name) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _c("b", [_vm._v("Departure date")]),
                            _vm._v(
                              "\n              : " +
                                _vm._s(
                                  _vm._f("formatDate")(flight.departureDate)
                                ) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _c("b", [_vm._v("Departure time")]),
                            _vm._v(
                              "\n              : " +
                                _vm._s(
                                  _vm._f("formatTime")(flight.departureDate)
                                ) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _c("b", [_vm._v("Arrival point")]),
                            _vm._v(
                              "\n              : " +
                                _vm._s(flight.arrivalAirport.name) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _c("b", [_vm._v("Arrival date")]),
                            _vm._v(
                              "\n              : " +
                                _vm._s(
                                  _vm._f("formatDate")(flight.arrivalDate)
                                ) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkout-end__info" }, [
                            _c("b", [_vm._v("Arrival time")]),
                            _vm._v(
                              "\n              : " +
                                _vm._s(
                                  _vm._f("formatTime")(flight.arrivalDate)
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]
                      )
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
        ]),
    _vm._v(" "),
    _vm.departureDetails.errata.length
      ? _c("div", { staticClass: "departures__html-wrapper" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "departures__html" }, [
              _c(
                "ul",
                _vm._l(_vm.departureDetails.errata, function (errata) {
                  return _c("li", { key: errata, attrs: { value: errata } }, [
                    _vm._v(_vm._s(errata)),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }